import { render } from "./PopupCustomBuy.vue?vue&type=template&id=388bcde7&scoped=true"
import script from "./PopupCustomBuy.vue?vue&type=script&lang=js"
export * from "./PopupCustomBuy.vue?vue&type=script&lang=js"

import "./PopupCustomBuy.vue?vue&type=style&index=0&id=388bcde7&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza_airdrop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388bcde7"]])

export default __exports__